/**
 * Fade slideshow — replaces the default scroll-based transition with opacity fade.
 * Only activates on slideshow-component elements that contain a .slideshow--fade element.
 */
(function () {
  function initFadeSlideshow(component) {
    const slider = component.querySelector('.slideshow--fade');
    if (!slider) return;

    const slides = Array.from(component.querySelectorAll('.slideshow__slide'));
    if (slides.length < 2) return;

    const speed = (parseInt(slider.dataset.speed) || 5) * 1000;
    const shouldAutoplay = slider.dataset.autoplay === 'true';
    let currentIndex = 0;
    let autoplayInterval = null;

    // Stop the original SlideshowComponent autoplay
    if (typeof component.autoplay !== 'undefined') {
      clearInterval(component.autoplay);
    }

    function updateDots(index) {
      const dots = component.querySelectorAll('.slider-counter__link');
      dots.forEach((dot, i) => {
        dot.classList.toggle('slider-counter__link--active', i === index);
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function goToSlide(index) {
      slides.forEach((slide, i) => {
        if (i === index) {
          slide.setAttribute('aria-hidden', 'false');
          slide.removeAttribute('tabindex');
          slide.querySelectorAll('a, button').forEach((el) => el.removeAttribute('tabindex'));
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('tabindex', '-1');
          slide.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
        }
      });
      currentIndex = index;
      updateDots(index);
    }

    function startAutoplay() {
      if (!shouldAutoplay) return;
      clearInterval(autoplayInterval);
      autoplayInterval = setInterval(() => {
        goToSlide((currentIndex + 1) % slides.length);
      }, speed);
    }

    function stopAutoplay() {
      clearInterval(autoplayInterval);
    }

    // Prev / next buttons — capture phase so we run before SlideshowComponent handlers
    const prevBtn = component.querySelector('button[name="previous"]');
    const nextBtn = component.querySelector('button[name="next"]');

    if (prevBtn) {
      prevBtn.addEventListener(
        'click',
        (e) => {
          e.stopImmediatePropagation();
          stopAutoplay();
          goToSlide((currentIndex - 1 + slides.length) % slides.length);
          startAutoplay();
        },
        { capture: true }
      );
    }

    if (nextBtn) {
      nextBtn.addEventListener(
        'click',
        (e) => {
          e.stopImmediatePropagation();
          stopAutoplay();
          goToSlide((currentIndex + 1) % slides.length);
          startAutoplay();
        },
        { capture: true }
      );
    }

    // Dot navigation
    component.querySelectorAll('.slider-counter__link').forEach((dot, i) => {
      dot.addEventListener(
        'click',
        (e) => {
          e.stopImmediatePropagation();
          stopAutoplay();
          goToSlide(i);
          startAutoplay();
        },
        { capture: true }
      );
    });

    // Pause/play button
    const pauseBtn = component.querySelector('.slideshow__autoplay');
    if (pauseBtn) {
      let isPaused = false;
      pauseBtn.addEventListener('click', () => {
        isPaused = !isPaused;
        isPaused ? stopAutoplay() : startAutoplay();
      });
    }

    // Pause on hover
    component.addEventListener('mouseenter', stopAutoplay);
    component.addEventListener('mouseleave', startAutoplay);

    // Initialize
    goToSlide(0);
    startAutoplay();
  }

  // Run after custom elements are defined and DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  function run() {
    customElements.whenDefined('slideshow-component').then(() => {
      document.querySelectorAll('slideshow-component').forEach((component) => {
        if (component.querySelector('.slideshow--fade')) {
          initFadeSlideshow(component);
        }
      });
    });
  }
})();
